import Konva from 'konva'

export class Group extends Konva.Group {
  // This is an override of the default getClientRect method.
  // We want to be able to ignore some nodes when calculating the total client rectangle.
  // We do this by ignoring any children that have an attribute hideFromGroupCalc set to true.
  // The only line that's changed from the original implementation is the line
  // that references child.attrs.hideFromGroupCalc
  getClientRect(config = {}) {
    const skipTransform = config.skipTransform
    const relativeTo = config.relativeTo

    let minX, minY, maxX, maxY
    let selfRect = {
      x: Infinity,
      y: Infinity,
      width: 0,
      height: 0
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    this.children?.forEach(function (child) {
      // skip invisible children and the text node
      if (!child.visible() || child.attrs.hideFromGroupCalc) {
        return
      }

      const rect = child.getClientRect({
        relativeTo: that,
        skipShadow: config.skipShadow,
        skipStroke: config.skipStroke
      })

      // skip invisible children (like empty groups)
      if (rect.width === 0 && rect.height === 0) {
        return
      }

      if (minX === undefined) {
        // initial value for first child
        minX = rect.x
        minY = rect.y
        maxX = rect.x + rect.width
        maxY = rect.y + rect.height
      } else {
        minX = Math.min(minX, rect.x)
        minY = Math.min(minY, rect.y)
        maxX = Math.max(maxX, rect.x + rect.width)
        maxY = Math.max(maxY, rect.y + rect.height)
      }
    })

    // if child is group we need to make sure it has visible shapes inside
    const shapes = this.find('Shape')
    let hasVisible = false
    for (let i = 0; i < shapes.length; i++) {
      const shape = shapes[i]
      if (shape._isVisible(this)) {
        hasVisible = true
        break
      }
    }
    if (hasVisible && minX !== undefined) {
      selfRect = {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
      }
    } else {
      selfRect = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      }
    }

    if (!skipTransform) {
      return this._transformedRect(selfRect, relativeTo)
    }
    return selfRect
  }
}
